import React from 'react';
import Navigation from 'views/EMR/Settings/Navigation';
import {
  Outlet,
} from 'react-router-dom';

export default function Settings() {
  return (
    <div className="h-full w-full">
      <div className="h-full w-full max-h-[calc(100vh-1.5rem)] overflow-y-hidden">
        <div className="flex flex-col w-full h-full">
          <Navigation />
          <div className="flex-1 w-full overflow-y-hidden pt-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
